var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PersonVacationListWeb"},[_c('v-data-table',{attrs:{"dense":"","disable-sort":true,"headers":_vm.headers,"hide-default-footer":"","disable-pagination":"","items":_vm.list,"item-key":"MessageId"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }